import { IconDefinition, IconName, IconPrefix } from '@fortawesome/fontawesome-svg-core';

const faVLabel: IconDefinition = {
    icon: [
        // SVG viewbox width (in pixels)
        512,

        // SVG viewbox height (in pixels)
        512,

        // Aliases (not needed)
        [],

        // Unicode as hex value (not needed)
        '',

        // SVG path data
        'M0 256C0 115.2 114.2 0 256 0C396.5 0 512 115.2 512 256C512 396.8 396.5 512 256 512C114.2 512 0 396.8 0 256ZM255.4 478.8C255.4 478.8 257.9 465.7 258.5 460C264.2 428.8 268.5 396.2 277.3 365.5C288 330.5 299.3 292.9 317.5 260.4C320.6 255.4 325.6 246 332.5 246.6C352 245.4 371.5 240.4 387.1 229.1C399.7 220.9 409.1 211.6 415.4 198.4C421 185.3 423.5 172.8 423.5 158.4C424.8 145.2 426.7 133.9 431.7 122.1C433.6 118.9 434.8 115.8 434.8 112.7C427.3 111.4 417.9 117 411 119.5C394.7 124.6 377.1 126.4 360.8 128.9C348.2 130.8 335.1 134.6 324.4 142.1C306.2 154.6 296.2 169.6 289.3 190.3C286.1 202.2 283 215.9 283.6 227.8C284.2 229.1 284.2 229.1 284.2 229.1C287.4 228.5 293 219.1 294.9 216.6C306.2 200.3 316.9 185.3 333.2 173.4C336.3 172.1 352 164 353.9 168.4C353.3 174 344.5 180.9 340.7 185.3C307.5 221.6 288 271.6 269.8 316.1C259.8 341.1 253.5 367.4 242.2 391.8C241.6 392.4 240.9 394.3 239.7 395C236.5 391.8 235.3 384.9 234.7 380.6C230.3 363 226.5 344.9 222.1 328C210.8 281.7 198.3 227.8 171.9 188.4C151.2 159.6 123.6 126.4 89.7 113.3C89.1 113.3 88.5 113.3 87.8 113.3C86.6 115.8 89.1 118.3 91 120.2C130.5 163.4 162.5 221.6 178.8 277.9C195.1 337.4 210.8 400 219.6 461.3C220.9 466.3 221.5 476.9 221.5 476.9C221.5 476.9 232.2 478.2 238.4 478.8C244.1 479.5 255.4 478.8 255.4 478.8Z',
    ],
    iconName: 'faVLabel' as IconName,
    prefix: 'simple-icons' as IconPrefix,
};

export default faVLabel;
